import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';

@Component({
  selector: 'app-biller-note-modal',
  templateUrl: './biller-note-modal.component.html',
  styleUrls: ['./biller-note-modal.component.css']
})
export class BillerNoteModalComponent implements OnInit, OnDestroy {
  @Input() trip;
  @Output() billerNoteAdded = new EventEmitter<any>();
  reasonSubmitted:boolean = false;

  constructor(
    private assignTripService: AssigTripsService
  ) { }

  ngOnInit() {
  }

  addBillerNote() {
    this.reasonSubmitted = true;

    if(this.trip.billerNote == ''){
      return
    }

    this.assignTripService
      .addBillerNote(this.trip)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.billerNoteAdded.emit(data);
        }
      });
  }

  closeModal() {
    this.billerNoteAdded.emit(null)
  }

  ngOnDestroy(): void {
  }
}
